import { Box, Typography } from "@mui/material";
import { CaptchaDetailsForm } from "../../models/CaptureDetailsForm";

export interface TaxPayerDetailsDisplayProps {
  form: CaptchaDetailsForm;
}

function TaxPayerDetailsDisplay(props: TaxPayerDetailsDisplayProps) {
    return (
        <Box sx={(theme) => ({ mr: "22px", backgroundColor: "#E3EFF57D", borderRadius: "8px", p: "22px", flex: "0 0 15rem", height: "80%", [theme.breakpoints.down('md')]: {width: "-webkit-fill-available", mb: "12px", flex: "auto"} })}>
            <Typography sx={{ color: '#00558B', fontWeight: "bold", pb: "22px" }}>Taxpayer Details</Typography>
            <Box sx={(theme) => ({[theme.breakpoints.down('md')]: {display: "flex", alignItems: "center", justifyContent: "space-between"}, [theme.breakpoints.down('sm')]: {flexDirection: "column", alignItems: "flex-start"}})}>
                <Box>
                    <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Entity Type</Typography>
                    <Typography sx={{ fontSize: "16px" }}>{props.form.entityType}</Typography>
                </Box>

                {props.form.entityType === "Company"
                    ? <Box sx={{ mt: "12px" }}>
                        <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Company Registration Number</Typography>
                        <Typography sx={{ fontSize: "16px" }}>{props.form.companyRegNo}</Typography>
                    </Box>
                    : null
                }

                {props.form.entityType === "Trust"
                    ? <>
                        <Box sx={{ mt: "12px" }}>
                            <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Trust Type</Typography>
                            <Typography sx={{ fontSize: "16px" }}>{props.form.trustType}</Typography>
                        </Box>
                        {props.form.trustRegNo && props.form.trustRegNo !== "" ? <Box sx={{ mt: "12px" }}>
                            <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Trust Registration Number</Typography>
                            <Typography sx={{ fontSize: "16px" }}>{props.form.trustRegNo}</Typography>
                        </Box> : <Box sx={{ mt: "12px" }}>
                            <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Income Tax Number</Typography>
                            <Typography sx={{ fontSize: "16px" }}>{props.form.taxNumber}</Typography>
                        </Box>}
                    </>
                    : null
                }

                {props.form.entityType === "Individual"
                    ? <>
                        <Box sx={{ mt: "12px" }}>
                            {props.form.taxpayer_idType === "id_number"
                                ?   <>
                                        <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>South African ID Number</Typography>
                                        <Typography sx={{ fontSize: "16px" }}>{props.form.taxpayer_idNumber}</Typography>
                                    </>
                                : null
                            }

                            {props.form.taxpayer_idType === "passport_number"
                                ?   <>
                                        <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Passport Number</Typography>
                                        <Typography sx={{ fontSize: "16px" }}>{props.form.taxpayer_passportNo}</Typography>
                                    </>
                                : null
                            }

                            {props.form.taxpayer_idType === "asylum_seeker"
                                ?   <>
                                        <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Asylum Seeker Number</Typography>
                                        <Typography sx={{ fontSize: "16px" }}>{props.form.taxpayer_asylumNo}</Typography>
                                    </>
                                : null
                            }
                        </Box>
                    </>
                    : null
                }

                {props.form.entityType === "SMME"
                    ? <>
                        <Box sx={{ mt: "12px" }}>
                            <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>SMME Type</Typography>
                            <Typography sx={{ fontSize: "16px" }}>{props.form.smmeType === "company" ? "Company" : "Sole Proprietor"}</Typography>
                        </Box>
                        {props.form.smmeType === "company"
                            ? <Box sx={{ mt: "12px" }}>
                                <Typography sx={{ color: '#00558B', fontWeight: "bold", fontSize: "12px" }}>Company Registration Number</Typography>
                                <Typography sx={{ fontSize: "16px" }}>{props.form.companyRegNo}</Typography>
                            </Box>
                            : null
                        }
                    </>
                    : null
                }
            </Box>
        </Box>
    );
}

export default TaxPayerDetailsDisplay;
